import { UserAdapters } from '../adapters';
import { UsersApi } from '../clients';

export const getInternalUsersByRole = async (role) => {
  const response = await UsersApi.getInternalUsersByRole(role);

  return UserAdapters.toGetInternalUsersResult(response);
};
